import { LocationDetailModel, LocationRequestModel, LocationResponseModel } from "@/models/location";
import { AxiosResponse } from "axios";
import { deleteAsync, getAsync, postAsync, putAsync } from "./http-client";

const baseUrl = `${process.env.REACT_APP_API_ENDPOINT_Portal}/v1/location`;

function getLocations(): Promise<AxiosResponse<LocationResponseModel[]>> {
  const url = `${baseUrl}`;
  return getAsync(url);
}

function getLocation(id: string): Promise<AxiosResponse<LocationDetailModel>> {
  const url = `${baseUrl}/${id}`;
  return getAsync(url);
}

function createLocation(
    model: LocationRequestModel
  ): Promise<AxiosResponse<LocationRequestModel>> {
    const url = `${baseUrl}/add`;
    return postAsync(url, model, true, true);
  }

function updateLocation(
  model: LocationRequestModel
): Promise<AxiosResponse<LocationRequestModel>> {
  const url = `${baseUrl}/update`;
  return putAsync(url, model, true, true);
}

function activeLocation(id: string, isDeactive?: boolean) {
  const url = `${baseUrl}/active/${id}/${isDeactive}`;
  return postAsync(url, undefined, true, true);
}

function removeLocation(id: string) {
  const url = `${baseUrl}/${id}`;
  return deleteAsync(url);
}

export const LocationApi = {
    createLocation,
    getLocations,
    getLocation,
    updateLocation,
    activeLocation,
    removeLocation,
}